<button
  *ngIf="isVisible"
  class="back-to-top"
  (click)="backToTop()"
  aria-label="Back to Top"
></button>
